export default __webpack_public_path__ + "static/media/record_dot_red.2a4e53f1.svg";